import { get, set } from 'core-components/classes/services/StorageHelper'
import { STORAGE_KEY } from 'src/core/analytics/constants/MeasureControllerConstants'
import Logger from 'src/core/utils/Logger'

export const logMessage = (message: string) => {
  if (get(STORAGE_KEY) === 'true') {
    Logger.log(`MeasureController::: ${message}`)
  }
}
// @ts-ignore
window.toggleMeasureLog = (toggle: boolean) => {
  set(STORAGE_KEY, `${toggle}`)
}
